import * as React from "react";
import { PieLabelRenderProps } from "recharts";
import {
  MaterialProperty,
  PieRow,
} from "../../../../../../smokepit/src/types/MaterialVolumes";

const RADIAN = Math.PI / 180;

interface PieLabelProps extends PieLabelRenderProps {
  pieData: PieRow[];
  convertAndFormatPropertyValue: (
    volume: number,
    prop: MaterialProperty
  ) => string;
}

export const PieLabel: React.FC<PieLabelProps> = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  name,
  value,
  pieData,
  convertAndFormatPropertyValue,
}) => {
  if (
    cx == null ||
    cy == null ||
    innerRadius == null ||
    outerRadius == null
  ) {
    return null;
  }
  const radius = Number(outerRadius) + 20;
  const ncx = Number(cx);
  const x = ncx + radius * Math.cos(-(midAngle ?? 0) * RADIAN);
  const ncy = Number(cy);
  const y = ncy + radius * Math.sin(-(midAngle ?? 0) * RADIAN);
  const dataEntry = pieData.find((entry) => entry.name === name);
  const formattedValue = dataEntry?.materialProperty
    ? convertAndFormatPropertyValue(Number(value), dataEntry.materialProperty)
    : `${Number(value).toLocaleString()}`;
  const displayName = dataEntry?.name || name || "Unknown";

  return (
    <text
      x={x}
      y={y}
      fill="var(--neutral-2)"
      textAnchor={x > ncx ? "start" : "end"}
      dominantBaseline="central"
      fontSize={12}
    >
      {`${displayName}: ${formattedValue}`}
    </text>
  );
};
